import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { CustomRendererComponentProps } from 'js/src/agent/types';
import { VideoDraftTile } from 'js/src/components/video-planner/VideoDraftTile';
import {
    getVideoDraftById,
    selectSelectedVideoDraft,
    setSelectedVideoDraft,
} from 'js/src/data/video-planner';
import type { RootState } from 'js/src/libs/RootState';

const VideoDraftResultRendererComponent: React.FC<CustomRendererComponentProps> = ({
    toolCall,
}) => {
    const dispatch = useDispatch();
    if (!toolCall) throw new Error('VideoDraftResultRenderer requires a toolCall');
    const videoDraftId = toolCall.id;
    const videoDraft = useSelector((state: RootState) => getVideoDraftById(state, videoDraftId));
    const selectedVideoDraftId = useSelector(selectSelectedVideoDraft);

    const handleSelect = useCallback(
        (id: string) => {
            dispatch(setSelectedVideoDraft(id));
        },
        [dispatch],
    );

    const isSelected = selectedVideoDraftId === videoDraftId;

    if (!videoDraft) {
        return null;
    }

    if (videoDraft.error_message) {
        return (
            <div className="d-flex align-items-center text-danger">
                <i translate="no" className="material-symbols-outlined me-l5-4">
                    error_outline
                </i>
                <span>{videoDraft.error_message}</span>
            </div>
        );
    }

    return (
        <VideoDraftTile
            videoDraftId={videoDraftId}
            isSelected={isSelected}
            onSelect={handleSelect}
        />
    );
};

export const VideoDraftResultRenderer = memo(VideoDraftResultRendererComponent);
